<template>
    <a :href="bALink" class="footer-wrapper" ref="footer">
      {{ bAName }}
    </a>
</template>

<script>
 export default {
     props: {
         bALink: {
             type: String,
             default: 'https://beian.miit.gov.cn/'
         },
         bAName: {
             type: String,
             default: '浙ICP备18054152号-5' 
         }
     },
     data() {
         return {}
     }
 }   
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";

@media screen and (max-width:1440px){
    .footer-wrapper{
        height: 30px;
        line-height: 30px;
    }
}
@media screen and (min-width:1440px) and (max-width:1600px){
    .footer-wrapper{
        height: 40px;
        line-height: 40px;
    }
}
@media screen and (min-width:1600px){
    .footer-wrapper{
        height: 60px;
        line-height: 60px;
    }
}
.footer-wrapper {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 200;
    width: 100%;
    text-align: center;
    background: rgba(255, 255, 255, 0.65);
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/components/Footers.vue